import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function useSEO({ title, description, jsonLd }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const fullTitle = `${title} | Vikas Rolls Private Limited`;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", window.location.origin + pathname);
    setMeta("property", "og:image", window.location.origin + "/images/banner_roler.png");

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.origin + pathname);

    const prev = document.getElementById("page-jsonld");
    if (prev) prev.remove();
    if (jsonLd) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "page-jsonld";
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, pathname, jsonLd]);
}

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": ["Organization", "LocalBusiness"],
  name: "Vikas Rolls Private Limited",
  foundingDate: "1970",
  url: typeof window !== "undefined" ? window.location.origin : "",
  telephone: "+91 9810409131",
  email: "info@vikasrolls.in",
  address: {
    "@type": "PostalAddress",
    streetAddress: "1273-1274, MIE, Red Cross Road",
    addressLocality: "Bahadurgarh",
    addressRegion: "Haryana",
    postalCode: "124507",
    addressCountry: "IN",
  },
  description:
    "Indian manufacturer of industrial rolls since 1970 — rubber, polyurethane, steel, hard chromed and induction hardened rolls, with complete covering, machining and refurbishment services.",
};
